<template>
  <div :class="classes">
    <pt-page-title :title="posterData.name"></pt-page-title>
    <div v-if="posterData">
      <pt-sub-title title="视频信息"></pt-sub-title>
      <pt-form-item class="special" label="视频名称：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{posterData.name}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="视频封面图：" :labelWidth="labelWidth" v-if="posterData.imageUrl" :lineHeight="lineHeight">
        <pt-img :src="$publicResourcesUrl + posterData.imageUrl" :isPublic="true" class="quaImages"></pt-img>
      </pt-form-item>
      <pt-form-item class="special" label="复制链接：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <pt-copy-button style="padding-top:0;padding-bottom:0;" type="text" :copyContent="$publicResourcesUrl + posterData.contentUrl" text="点击复制"></pt-copy-button>
      </pt-form-item>
      <pt-form-item class="special" label="是否在工具中心展示：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{posterData.visibleInTools ? '是' :'否'}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="创建时间：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{posterData.createTime_copy}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="视频状态：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{posterData.status_copy}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="驳回原因：" :labelWidth="labelWidth" :lineHeight="lineHeight" v-if="posterData.status ==='DECLINED'">
        <span>{{posterData.reason}}</span>
      </pt-form-item>
    </div>
    <div class="marginTop">
      <el-button type="primary" @click="goEdit(posterData)">编辑</el-button>
    </div>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-video-detail'

export default {
  name: 'pt-video-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    poster: {
      type: Object,
      default: () => {
        return {
          base: {}
        }
      }
    }
  },
  watch: {
    poster (val) {
      this.posterData = val
    }
  },
  data () {
    return {
      labelWidth: '150px',
      lineHeight: '26',
      posterData: this.poster
    }
  },
  methods: {
    goEdit (data) {
      this.$router.push(`/video-manage/video-form/true/${data.id}`)
    }
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
@import '~less/var.less';

/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-video-detail{
  .special >span{
    color:@mainColor;
  }
  .quaImages{
    width:204px;
    height: 128px;
  }
  .pictureNames{
    display: flex;
    margin:0;
    padding-left: 0;
    li{
      width:204px;
      line-height: 20px;
      text-align: center;
    }
  }
}
</style>
